import { styled } from "@mui/material/styles";

export const SessionCardContainer = styled("div")<{ isPriority: boolean }>(({ theme, isPriority }) => ({
    position: "relative",
  // TODO: remove comments after session images gallery is implemented
  // aspectRatio: 0.7, 

  display: "flex",
  maxWidth: "414px",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "space-between",
  alignSelf: "stretch",
  flexGrow: 1,
  borderRadius: "1rem",
  overflow: "hidden",
  
  background: theme.colors["neutral.900"],

  boxShadow: isPriority ? '0px 34px 56px -32px #FFC90DCC' : 'none',


  cursor: "pointer",

  //temporary hover effect - To be aligned with Martin
  transition: 'transform .5s',

  "&:hover, &:focus": {
    transform: 'scale3d(1.035, 1.035, 1)',
  },
  "@media (max-width: 600px)": {
    maxWidth: "100%",
  },
}));

export const SessionCardBottomBar = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  alignSelf: "stretch",
  padding: "1rem",
}));
